import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "../../components/ui/button.jsx";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../components/ui/dropdown-menu.jsx";
import { removeUser, useIsUserAdmin } from '../../hooks/authHelpers.js';
import { useAuth, useUser } from '@clerk/clerk-react';
import * as Sentry from "@sentry/react";


const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { signOut } = useAuth();

    const { isSignedIn, isLoaded } = useAuth();
    const { user } = useUser();

    const isAuthenticated = isSignedIn && isLoaded;

    const isAdmin = useIsUserAdmin();

    useEffect(() => {
        if (isAuthenticated && user) {
            Sentry.setUser({
                id: user.id,
                email: user.primaryEmailAddress?.emailAddress || "",
            });
        } else {
            Sentry.setUser(null); // Clears user info on logout
        }
    }, [isAuthenticated, user]);

    if (!isLoaded) {
        return null;
    }

    return (
        <nav className="p-4 shadow-lg">
            <div className="container mx-auto flex justify-between items-center pr-0 pl-0">
                {/* Logo and Brand Name */}
                <Link to="/">
                    <img
                        src={`${process.env.PUBLIC_URL}/logo.png`}
                        alt="Logo"
                        width="100"
                    />
                </Link>

                {/* Desktop Menu */}
                <div className="hidden md:flex space-x-6 items-center">
                    {isAuthenticated && <Link to="/" className="text-black hover:text-gray-200 transition-colors">Communities</Link>}
                    {(isAuthenticated && isAdmin) && <Link to="/companies" className="text-black hover:text-gray-200 transition-colors">Companies</Link>}
                    {!isAuthenticated && <Link to="/login" className="text-black hover:text-gray-200 transition-colors">Login</Link>}
                    {(isAuthenticated && isAdmin) && <Link to="/health-page" className="text-black hover:text-gray-200 transition-colors">Health</Link>}

                    {/* Dropdown Menu (User Actions) */}
                    {isAuthenticated && <DropdownMenu>
                        <DropdownMenuTrigger className='text-black hover:text-gray-200 transition-color'>Settings</DropdownMenuTrigger>
                        <DropdownMenuContent>
                            {isAdmin && <DropdownMenuItem>
                                <Link to="/users" className="w-full text-black">Manage Users</Link>
                            </DropdownMenuItem>}
                            {/* <DropdownMenuItem>
                <Link to="/profile" className="w-full text-black">Profile</Link>
              </DropdownMenuItem> */}
                            <DropdownMenuItem>
                                <Link to="/" onClick={() => signOut(removeUser)} className="w-full text-black">Logout</Link>
                            </DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>}
                </div>

                {/* Mobile Menu Button */}
                <div className="md:hidden">
                    <Button
                        variant="ghost"
                        className="p-2 text-black hover:bg-gray-200 focus:outline-none"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        <svg
                            className="h-6 w-6"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            {isOpen ? (
                                <path d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path d="M4 5h16M4 12h16M4 19h16" />
                            )}
                        </svg>
                    </Button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isOpen && (
                <div className="md:hidden mt-4 space-y-2 p-4 rounded-lg shadow-lg">
                    {isAuthenticated && <Link to="/" className="block hover:bg-gray-200 text-black px-4 py-2 rounded">Communities</Link>}
                    {(isAuthenticated && isAdmin) && <Link to="/companies" className="block hover:bg-gray-200 text-black px-4 py-2 rounded">Companies</Link>}
                    {!isAuthenticated && <Link to="/login" className="block hover:bg-gray-200 text-black px-4 py-2 rounded">Login</Link>}
                    {(isAuthenticated && isAdmin) && <Link to="/health-page" className="block hover:bg-gray-200 text-black px-4 py-2 rounded">Health</Link>}

                    {/* Mobile Dropdown Menu */}
                    <DropdownMenu className="w-full">
                        <DropdownMenuTrigger className='block text-black px-4 py-2 rounded w-full text-left hover:bg-gray-200'>Settings</DropdownMenuTrigger>
                        <DropdownMenuContent className="w-full">
                            {isAdmin && <DropdownMenuItem className="w-full">
                                <Link to="/users" className="block w-full text-black">Manage Users</Link>
                            </DropdownMenuItem>}
                            {/* <DropdownMenuItem>
                <Link to="/settings" className="block w-full text-black">Settings</Link>
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Link to="/profile" className="block w-full text-black">Profile</Link>
              </DropdownMenuItem> */}
                            {isAuthenticated &&
                                <DropdownMenuItem className="w-full">
                                    <Link to="/" onClick={signOut} className="block w-full text-black">Logout</Link>
                                </DropdownMenuItem>
                            }
                        </DropdownMenuContent>
                    </DropdownMenu>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
